(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const bars = document.querySelectorAll('.announcement-bar[data-rotate]');

    bars.forEach((bar) => {
      const messages = bar.querySelectorAll('.announcement-bar__message');
      if (messages.length < 2) return;

      let index = 0;
      setInterval(() => {
        messages[index].classList.remove('is-active');
        index = (index + 1) % messages.length;
        messages[index].classList.add('is-active');
      }, 5000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="language_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('ul'),
        };
        this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.querySelectorAll('a').forEach((item) => {
          item.addEventListener('click', this.onItemClick.bind(this));
        });
      }

      toggleSelector() {
        const expanded = this.elements.button.getAttribute('aria-expanded') === 'true';
        this.elements.button.setAttribute('aria-expanded', (!expanded).toString());
        this.elements.panel.toggleAttribute('hidden');
      }

      closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
        }
      }

      onKeyUp(event) {
        if (event.code !== 'Escape') return;
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        this.elements.input.value = event.currentTarget.dataset.value;
        this.querySelector('form').submit();
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }

  document.addEventListener('cart:count-updated', (event) => {
    const countEl = document.querySelector('[data-cart-count]');
    if (!countEl) return;
    const count = event.detail.item_count;
    countEl.textContent = count;
    countEl.hidden = count === 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      constructor() {
        super();
        this.mainItems = Array.from(this.querySelectorAll('.product-gallery__main-item'));
        this.thumbs = Array.from(this.querySelectorAll('.product-gallery__thumb'));
        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.setActive(thumb.dataset.index));
        });
      }

      setActive(index) {
        this.mainItems.forEach((item) => {
          item.hidden = item.dataset.index !== index;
        });
        this.thumbs.forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.dataset.index === index);
        });
      }

      showImageById(imageId) {
        if (!imageId) return false;
        const item = this.mainItems.find((el) => el.dataset.imageId === String(imageId));
        if (!item) return false;
        this.setActive(item.dataset.index);
        return true;
      }
    }

    customElements.define('product-gallery', ProductGallery);
  }

  if (!customElements.get('product-form')) {
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.errorEl = this.querySelector('[data-form-error]');
        this.variantInput = this.querySelector('[data-variant-id]');
        this.priceEl = this.closest('.product__info')?.querySelector('[data-product-price]');
        this.submitBtn = this.querySelector('[data-add-to-cart]');
        this.gallery = document.querySelector('product-gallery');
        this.variants = JSON.parse(this.querySelector('[data-variant-json]')?.textContent || '[]');

        // Clone the array: it must NOT be the same reference as the matched variant's
        // own `options` array, otherwise mutating it below also mutates that variant
        // object, which then always matches itself and locks add-to-cart onto the
        // original default variant no matter what the shopper selects.
        const initialVariant = this.variants.find((v) => String(v.id) === this.variantInput.value);
        this.selectedOptions = [...(initialVariant?.options || [])];

        // Fallback map: value -> first image found for any variant carrying that value.
        // Used only when the exact matched variant has no image of its own, so a
        // colour swatch still swaps the photo even on partially-imaged catalogs.
        this.imageByOptionValue = {};
        this.variants.forEach((variant) => {
          if (!variant.featuredImageId) return;
          variant.options.forEach((value) => {
            if (!this.imageByOptionValue[value]) {
              this.imageByOptionValue[value] = variant.featuredImageId;
            }
          });
        });

        this.querySelectorAll('.product-form__value').forEach((btn) => {
          btn.addEventListener('click', () => this.selectOption(btn));
        });

        this.quantityInput = this.querySelector('input[name="quantity"]');
        this.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => this.adjustQuantity(-1));
        this.querySelector('[data-quantity-increase]')?.addEventListener('click', () => this.adjustQuantity(1));

        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (this.submitBtn.disabled) return;

        this.hideError();
        const originalLabel = this.submitBtn.textContent;
        this.submitBtn.disabled = true;
        this.submitBtn.textContent = this.dataset.addingLabel;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form),
          });
          const result = await response.json();

          if (!response.ok) {
            this.showError(result.description || this.dataset.genericError);
            return;
          }

          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        } catch (error) {
          this.showError(this.dataset.genericError);
        } finally {
          this.submitBtn.disabled = false;
          this.submitBtn.textContent = originalLabel;
        }
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
      }

      adjustQuantity(delta) {
        const value = Math.max(1, (parseInt(this.quantityInput.value, 10) || 1) + delta);
        this.quantityInput.value = value;
      }

      selectOption(button) {
        const index = Number(button.dataset.optionIndex);
        this.selectedOptions[index] = button.dataset.value;

        const group = button.closest('.product-form__option');
        group.querySelectorAll('.product-form__value').forEach((el) => el.classList.remove('is-selected'));
        button.classList.add('is-selected');
        group.querySelector('.product-form__option-value').textContent = button.dataset.value;

        const match = this.variants.find((variant) =>
          variant.options.every((option, i) => option === this.selectedOptions[i])
        );

        if (!match) return;

        this.variantInput.value = match.id;
        this.updatePrice(match);
        this.updateAvailability(match);

        if (this.gallery) {
          const imageId = match.featuredImageId || this.imageByOptionValue[button.dataset.value];
          this.gallery.showImageById(imageId);
        }
      }

      updatePrice(variant) {
        if (!this.priceEl) return;

        if (variant.compareHtml) {
          this.priceEl.innerHTML =
            `<span class="product__price-sale">${variant.priceHtml}</span>` +
            `<span class="product__price-compare">${variant.compareHtml}</span>` +
            `<span class="product__price-badge">-${variant.badgePct}%</span>`;
        } else {
          this.priceEl.innerHTML = `<span>${variant.priceHtml}</span>`;
        }
      }

      updateAvailability(variant) {
        if (!this.submitBtn) return;
        this.submitBtn.disabled = !variant.available;
        this.submitBtn.textContent = variant.available
          ? this.dataset.addToCartLabel
          : this.dataset.soldOutLabel;
      }
    }

    customElements.define('product-form', ProductForm);
  }

  } catch(e) { console.error(e); }
})();
})();
